// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"InformationPaywall_dialogWrapper__xsCUC","dialogFooter":"InformationPaywall_dialogFooter__3Qcbw","footerButtonText":"InformationPaywall_footerButtonText__IcbnV"};